import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation } from '@tanstack/react-query';
import { ErgonomicWorkAnalysisService } from '@/infra/services/ergonomic-work-analysis';

interface CreateErgonomicWorkAnalysisUrlSignedParams {
	id: string;
	file_name: string;
	size_number: number;
	content_type: string;
	organization_id: string;
	company_id: string;
}

const Service = ErgonomicWorkAnalysisService.getInstance();

export const useCreateErgonomicWorkAnalysisUrlSigned = () => {
	return useMutation({
		mutationFn: async (params: CreateErgonomicWorkAnalysisUrlSignedParams) => Service.createUploadUrlSigned(params),
		onError: () => {
			message.error(I18n.get('Error creating signed URL'));
		}
	});
};
